import { queryOptions } from "@tanstack/react-query";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { fetchOccPageData, fetchOccResourcePageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { CartPageInitialData } from "./cartPageInitialData";

export const cartPageQueryOptions = (activeCartId?: string) =>
  queryOptions({
    queryKey: pageDataKeys.cart(activeCartId),
    queryFn: () => {
      if (!activeCartId) {
        return fetchOccPageData<PageInitialDataResult<CartPageInitialData>>("/page-data/cart");
      }

      return fetchOccResourcePageData<PageInitialDataResult<CartPageInitialData>>(
        `${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/page-data/cart`,
      );
    },
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
